<!-- <template>
    <el-table :data="data" border  style="width: 100%" v-bind="$attrs" v-on="$listeners" >
        <slot></slot>
    </el-table>
</template> -->
<script>
export default {
    props: ['data'],
    name: 'CustomTable',
    inheritAttrs: false,
    data() {
        return {
            device: "pc",
            cloumns: [],
            checkedValues: []
        }
    },
    render() {
        let isCheck = false
        const columnItem = (item,index) => {
            return this.cloumns.map((column, idx) => {
                let columnNode = ''
                if (column) {
                    if (column.scopedSlots) {
                        if ((idx + 1) == this.cloumns.length) {//最后一行
                            columnNode = <div class="card-item opreat">
                                <div class="card-item-content ">{this.getSlotVode(column.scopedSlots, item)}</div>
                            </div>
                        } else {
                            columnNode = <div class="card-item">
                                <div class=" card-item-title" >{column.attrs.label}：</div>
                                <div class="card-item-content ">{this.getSlotVode(column.scopedSlots, item)}</div>
                            </div>
                        }
                    } else {
                        if (column.attrs.type == "selection") {
                            isCheck = true
                            columnNode = <div class="card-item checkbox">
                                <input type="checkbox" on-change={this.handleCheckedValues} model={this.checkedValues} value={JSON.stringify(item)} />
                            </div>
                        } else if (column.attrs.type == "index") {
                            columnNode = <div class="card-item">
                                <div class=" card-item-title" >{column.attrs.label}：</div>
                                <div class="card-item-content ">{index + 1}</div>
                            </div>
                        } else {
                            if (column.attrs.formatter) {
                                // console.debug(column.attrs.formatter,column.attrs)
                                columnNode = <div class="card-item">
                                    <div class=" card-item-title" >{column.attrs.label}：</div>
                                    <div class="card-item-content ">{column.attrs.formatter(item, column.attrs, item[column.attrs.prop])}</div>
                                </div>
                            } else {
                                columnNode = <div class="card-item">
                                    <div class=" card-item-title" >{column.attrs.label}：</div>
                                    <div class="card-item-content ">{item[column.attrs.prop]}</div>
                                </div>
                            }
                        }
                    }
                }
                return columnNode
            })
        }

        const elcardItem = this.data && this.data.length > 0 ? this.data.map((item,index) => {
            return <el-card>
                <div class="card-box">
                    {columnItem(item,index)}
                </div>
            </el-card>
        }) : <el-empty description="暂无数据"></el-empty>

        const selectionAll = <div class="checkAll">
            <input type="checkbox" on-change={this.handleCheckedAllValues} model={this.checkedValues} value={JSON.stringify(this.data)} />
            <label>全选</label>
        </div>
        // const elTable=this.$createElement('el-table', {  
        //     props:{
        //         data:this.data,
        //         border:true,
        //         style:"width: 100%"
        //     },
        //     attrs: this.$attrs,  
        //     on: this.$listeners,  
        // }, this.$slots.default); 
        // const elTable =(<el-table data={this.data} border style="width: 100%" bind={this.$attrs} on={this.$listeners} >
        //                 {this.$slots.default}
        //             </el-table>)
        return (this.device == 'h5'
            ? <div>{isCheck ? selectionAll : ""}{elcardItem} </div>
            : <el-table data={this.data} border style="width: 100%" attrs={this.$attrs} on={this.$listeners}  >
                {this.$slots.default}
            </el-table>)
        // return false
    },
    created() {
        if (window.innerWidth < 1000) {
            this.device = 'h5'
        }
        // console.debug(this)
        if (this.$slots.default) {
            let cols = this.$slots.default;
            for (let i = 0; i < cols.length; i++) {
                this.cloumns.push(cols[i].data)
            }
        }
    },
    methods: {
        getSlotVode(scopedSlots, nodeData) {
            const btnNodes = scopedSlots.default({ row: nodeData })
            return btnNodes
        },
        handleCheckedValues($event) {
            console.debug($event.target.checked)
            const checkVal = JSON.parse($event.target._value)
            if ($event.target.checked) {
                this.checkedValues.push(checkVal)
            } else {
                this.checkedValues = this.checkedValues.filter(item => {
                    return item.id != checkVal.id
                })
            }
            console.debug(this.checkedValues)
            this.$listeners['selection-change'].fns(this.checkedValues)
            // this.checkedValues = val
            // this.$emit('checkedValues',val)
        },
        handleCheckedAllValues($event) {
            let checkboxes = document.querySelectorAll('.checkbox input[type="checkbox"]')
            if ($event.target.checked) {
                this.checkedValues = this.data
            } else {
                this.checkedValues = []
            }
            checkboxes.forEach(function (checkbox) {
                checkbox.checked = $event.target.checked;
            });
            this.$listeners['selection-change'].fns(this.checkedValues)
        }

    }
}
</script>
<style lang="less" scoped>
.checkAll {
    padding-left: 8px;

    input {
        vertical-align: middle;
    }

    label {
        margin-left: 6px;
        line-height: 20px;
        font-size: 14px;
    }
}

.card-box {
    display: flex;
    flex-wrap: wrap;

    .card-header {
        width: 100%;
        margin-bottom: 8px;
        border-bottom: 1px solid var(--blue);
        padding-bottom: 8px;
        font-size: 14px;
        font-weight: bold;

        .card-title {
            font-size: 14px;
            padding: 0 10px;
            color: var(--gray);
        }

        span {
            height: 32px;
        }
    }

    .checkbox {
        margin-right: 0px !important;
    }

    .fill {
        width: 100%;
    }

    .opreat {
        width: 100%;
        margin: 10px 0 0 !important;
        border-top: 1px solid var(--lightGray);
    }

    .card-item {
        display: flex;
        margin: 1px 10px;

        .card-item-title {
            font-size: 13px;
            min-width: 44px;
        }

        .card-item-content {
            font-size: 12px;
            color: var(--gray);
            flex: 1;
            .el-button{
                padding: 8px 6px;
            }
        }
    }


}

.el-card {
    margin: 4px 0;

    /deep/ .el-card__body {
        padding: 16px 16px 12px;
    }
}
</style>